import React from "react";
var __jsx = React.createElement;
import Reviews from './Reviews';
function ReviewsAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  var showBirdApiData = false;
  if (entry !== null && entry !== void 0 && entry.birdeyeApiBusinessId) {
    showBirdApiData = true;
  }
  return __jsx(Reviews, {
    reviewsData: entry,
    showBirdApiData: showBirdApiData,
    birdAPIData: data.reviewData,
    birdeyeApiBusinessId: entry.birdeyeApiBusinessId
  });
}
export default ReviewsAdapter;